import type { IconSvgObject } from './types';

const ShoppingBasketFavorite02Icon: IconSvgObject = [
  ["path", { d: "M7 8V6.5C7 4.01472 9.01472 2 11.5 2C13.9853 2 16 4.01472 16 6.5V8", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 22H6.73459C5.73929 22 4.89545 21.2681 4.75469 20.2828L3 8H20L19.5 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19.7431 15.2896C18.1465 14.457 17 15.6843 17 15.6843C17 15.6843 15.8535 14.457 14.2568 15.2896C12.323 16.298 12.1841 20.2469 17 22C21.816 20.2469 21.677 16.298 19.7431 15.2896Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 18L10 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ShoppingBasketFavorite02Icon;
